
import 'swiper/css/swiper.css'
import { Component, Vue } from 'vue-property-decorator'
import { ChangePasswordVO } from '@/views/biz/mypage/vo/mypage.vo'
import axios from 'axios'
import CommonUtils from '@/common-utils';

@Component
export default class FindPasswordRetype extends Vue {
  member: ChangePasswordVO = {} as ChangePasswordVO;
  checkPwd = '';
  
  isValidationMemPwd = false;
  isValidationMemPwd2 = false;


  // 비밀번호 검증
  get validateMemberPwd() {
    // 사용 가능한 비밀번호 입니다.
    let message = this.$t('join.t0002').toString();
    this.isValidationMemPwd = true;

    if(CommonUtils.validatePassword(this.member.newPassword) == false) {
      // 비밀번호는 영문과 숫자 조합(8자리 이상)
      message = this.$t('join.t0007').toString();
      this.isValidationMemPwd = false;
    }

    return message;
  }

  // 비밀번호 일치 검증
  get checkSamePassword() {
    // 비밀번호가 일치합니다.
    let message = this.$t('join.t0003').toString();
    this.isValidationMemPwd2 = true;

    if(this.member.newPassword != this.checkPwd) {
      // 비밀번호가 일치하지 않습니다.
      message = this.$t('join.t0005').toString();
      this.isValidationMemPwd2 = false;
    }

    return message;
  }


  // 비밀번호 변경
  save() {
    if(this.isValidationMemPwd == false || this.isValidationMemPwd2 == false) {
      // 비밀번호를 확인해주세요.
      return alert(this.$t('join.a0015'));
    }

    // 저장하시겠습니까?
    if (confirm(this.$t("common.c0002").toString()) == false) {
      return;
    }

    axios.put('/login/password', this.member)
    .then(r=>{
      if(r.data) {
        this.$router.push({name: 'FindPasswordResult'});
      }
    })
  }

  created() {
    if (window.opener) {
      window.opener.location.href = CommonUtils.createStaticUrl(this, 'FindPasswordRetype');
      window.close();
      return;
    }
  }
}
